import "shared/extensions/string";

import { PropsWithChildren, ReactElement, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { useStatusModal } from "shared/core/hooks/useStatusModal";
import { useTranslation } from "react-i18next";
import { handleWisdomStoreClick } from "core/helpers/mobileStore";

interface FeatureToggleProps extends PropsWithChildren {
  showFeature: boolean;
  triggerUpdateModal?: boolean;
  backPath?: string;
}

export const FeatureToggle = ({ children, showFeature, triggerUpdateModal, backPath: backUrl }: FeatureToggleProps): ReactElement => {
  const { isMobileApp, platform } = useMobilePlatform();
  const { t } = useTranslation(undefined, { keyPrefix: "featureToggle" });
  const navigate = useNavigate();
  const { Modal, setBody } = useStatusModal("feature-toggle");

  useEffect(() => {
    if (!showFeature && triggerUpdateModal) {
      setBody({
        data: {
          title: t("title"),
          description: t("description"),
          cta: t("cta"),
        },
        status: "info",
        cancelCallback: () => (backUrl ? navigate(backUrl) : navigate(-1)),
        callback: () => platform && handleWisdomStoreClick(platform, "feature_toggle"),
        ignoreHide: true,
      });
    }
  }, [backUrl, navigate, setBody, showFeature, t, triggerUpdateModal, platform]);

  if (!showFeature && triggerUpdateModal && isMobileApp) {
    return <>{Modal}</>;
  }

  if (!showFeature && !triggerUpdateModal) {
    return <Navigate to="/not-found" />;
  }

  return <>{children}</>;
};
